import { ModelFactory } from "../../../ModelFactory";

export class SiteConfig {
  constructor(
    public readonly certificate: string,
    public readonly phpVersion: string,
    public readonly phpPoolConfig: string,
    public readonly webserverConfig: string,
    public readonly aliasDomains: string[],
  ) {
  }
}

class SiteConfigFactory extends ModelFactory<SiteConfig> {
  protected fromJson(json: any): SiteConfig {
    return new SiteConfig(
      json['certificate'],
      json['php_version'],
      json['php_pool_config'],
      json['webserver_config'],
      json['alias_domains'] ?? [],
    );
  }
}
export const siteConfigFactory = new SiteConfigFactory();
